import { get, values, filter } from 'lodash'
import { createSelector } from 'reselect'

const isStandMatch = (preference, standId) => preference.standUuid === standId || !preference.standUuid

export const getAllCustomerOrderingPreferencesById = (state) => {
  return state?.customerOrderingPreference?.byId ?? {}
}

const customerOrderingPreferencesByType = (state, type) => {
  const allPrefs = getAllCustomerOrderingPreferencesById(state)
  const byType = filter(allPrefs, (pref) => pref.type === type)

  return byType
}

export const makeGetCustomerOrderingPreferencesByType = () => createSelector(
  [customerOrderingPreferencesByType], (preferences) => preferences
)

export const getAllCustomerStandPreferences = (state, customerId, standId) => {
  const allPrefs = values(get(state, 'customerOrderingPreference.byId', {}))

  return filter(allPrefs, (pref) => pref.customerId === customerId && isStandMatch(pref, standId))
}

export const makeGetAllCustomerStandPreferences = () => createSelector(
  [getAllCustomerStandPreferences], (preferences) => preferences
)

export const getDefaultPreferences = (state, standId) => {
  return state?.customerOrderingPreference?.defaultsByCustomerId ?? {}
}

export const getNewlyCreatedCustomerId = state => state?.customerOrderingPreference?.createdCustomerId

export const getNewlyRemovedCustomerId = state => state?.customerOrderingPreference?.removedCustomerId

export const getIsOrderingPreferencesLoading = state => state?.customerOrderingPreference?.isLoading ?? false
